import React,{ PureComponent } from 'react';
import { inModal } from '../../hoc/inModal';
import ModalTitle from '../common/ModalTitle';
import TextInput from '../common/TextInput';
import FormNewLine from '../common/FormNewLine';
import moment from 'moment'
import DatePicker from 'react-datepicker'
import SelectInput from '../common/SelectInput';
import apiClient from '../../apis'
import { formatNumberWithComma } from '../../common/util'
import { Formatter } from '../../utilities/Formatter'

export class CreateAdsForm extends PureComponent {
  constructor(props){
    super(props);

    this.state = {
      data: {
        adsName: props.selectedRecord ? props.selectedRecord.ads_name : '',
        startDate: props.selectedRecord ? props.selectedRecord.start_date : '',
        endDate: props.selectedRecord ? props.selectedRecord.end_date : '',
        cost: props.selectedRecord ? props.selectedRecord.cost.toString() : '',
        adsType: props.selectedRecord ?
          props.selectedRecord.ads_type === 'ออฟไลน์' ? 1 : 2 : null
      }
    }

    this.adsType = [
      {
        label: 'ออฟไลน์',
        value: 1
      },
      {
        label: 'ออนไลน์',
        value: 2
      }
    ]
  }

  handleDateChange(datetime, key) {
    const data = this.state.data
    data[key] = moment(datetime._d).format('YYYY-MM-DD')
    this.setState({
      [key]: datetime
    })
  }

  save = (skipRefreshFunc=false) => {
    if(!this.state.data.adsName){
      alert("กรุณากรอกชื่อสื่อโฆษณา");
      return Promise.reject();
    }
    else if(!this.state.data.adsType){
      alert("กรุณาเลือกชนิดโฆษณา");
      return Promise.reject();
    }
    else if(!this.state.data.startDate || !this.state.data.endDate){
      alert("กรุณากรอกวันที่ให้ครบ");
      return Promise.reject();
    }
    else if(moment(this.state.data.endDate, 'YYYY-MM-DD') < moment(this.state.data.startDate, 'YYYY-MM-DD')){
      alert("วันที่ไม่ถูกต้อง กรุณาใส่วันที่ใหม่");
      return Promise.reject();
    }
    else{
      const campaignId = this.props.campaignId
      const p = apiClient.campaign.createCampaignAds(campaignId, this.state.data).then(() => {
        this.props.closeModal()
        this.props.onCreateAds()
      })

      return p
    }
  }

  update = (skipRefreshFunc=false) => {
    if(!this.state.data.adsName){
      alert("กรุณากรอกชื่อสื่อโฆษณา");
      return Promise.reject();
    }
    else if(!this.state.data.adsType){
      alert("กรุณาเลือกชนิดโฆษณา");
      return Promise.reject();
    }
    else if(!this.state.data.startDate || !this.state.data.endDate){
      alert("กรุณากรอกวันที่ให้ครบ");
      return Promise.reject();
    }
    else if(moment(this.state.data.endDate, 'YYYY-MM-DD') < moment(this.state.data.startDate, 'YYYY-MM-DD')){
      alert("วันที่ไม่ถูกต้อง กรุณาใส่วันที่ใหม่");
      return Promise.reject();
    }
    else{
      const campaignId = this.props.campaignId
      const p = apiClient.campaign.updateCampaignAds(campaignId, this.props.selectedRecord.id, this.state.data).then(() => {
        this.props.closeModal()
        this.props.onUpdateAds()
      })

      return p
    }
  }

  delete = () => {
    const campaignId = this.props.campaignId
    const isConfirm = window.confirm(`คุณต้องการลบสื่อ ${this.props.selectedRecord.ads_name} ใช่หรือไม่?`)
    if (isConfirm) {
      const p = apiClient.campaign.deleteCampaignAds(campaignId, this.props.selectedRecord.id).then(() => {
        this.props.closeModal()
        this.props.onUpdateAds()
      })

      return p
    }
  }

  render() {
    const form = (
      <div className="d-flex flex-column" style={{ flexGrow: 1 }}>
          <div className="row">
              <div className="col-sm-6">
                <TextInput 
                  name="adsName"
                  placeholder="ชื่อ"
                  target={ this }
                  stateKey="data"
                  required={true}
                />
              </div>
              <div className="col-sm-3">
                <selectWrap>
                  <SelectInput 
                    name="adsType"
                    placeholder="ชนิดโฆษณา"
                    target={ this }
                    stateKey="data"
                    options={ this.adsType }
                  />
                </selectWrap>
              </div>
              <FormNewLine />
              <div className="col-sm-3 date-picker-position">
                <DatePicker
                  className="form-control input w-fit-content calendar-image"
                  selected={this.state.data.startDate ? moment(this.state.data.startDate) : this.state.data.startDate}
                  placeholderText="วันที่เริ่ม"
                  onChange={ (date) => this.handleDateChange(date ? date : '', 'startDate') }
                  dateFormat={this.state.data.startDate ? `${Formatter.formatDateTh(Formatter.createDate(this.state.data.startDate))}` : ''}
                  shouldCloseOnSelect={ true }
                  disabledKeyboardNavigation
                  required={ true }
                />
              </div>
              <div className="col-sm-3 date-picker-position">
                <DatePicker
                  className="form-control input w-fit-content calendar-image"
                  selected={this.state.data.endDate ? moment(this.state.data.endDate) : this.state.data.endDate}
                  placeholderText="วันที่สิ้นสุด"
                  onChange={ (date) => this.handleDateChange(date ? date : '', 'endDate') }
                  dateFormat={this.state.data.endDate ? `${Formatter.formatDateTh(Formatter.createDate(this.state.data.endDate))}` : ''}
                  minDate={ moment(this.state.data.startDate, 'YYYY-MM-DD').add(1, 'day') }
                  shouldCloseOnSelect={ true }
                  disabledKeyboardNavigation
                  disabled={ this.state.data.startDate ? false : true }
                  required={ true }
                />
              </div>
              <div className="col-sm-6">
                <TextInput
                  name="cost"
                  placeholder="ค่าใช้จ่าย (บาท)"
                  target={ this }
                  renderFormatter={value => formatNumberWithComma(value)}
                  dataFormatter={value => value.replace(/,/g, '')}
                  stateKey="data"
                />
              </div>
          </div>
      </div>
    )
    return (
      <div className="d-flex flex-column">
        <ModalTitle
          title={this.props.selectedRecord ? 'แก้ไขสื่อโฆษณา' : 'สร้างสื่อโฆษณา'}
          onClick={ () => {
            this.props.closeModal()
            this.props.onCloseModal()
          }}
        />
        {form}
        <div style={{paddingTop: "24px"}} className="d-flex flex-row justify-content-center">
          <button 
              style={{padding: 0}}
              onClick={ () => {
                this.props.closeModal()
                this.props.onCloseModal()
              }}
              className="m-05 btn btn-save-cancel btn-outline"
            >
              ยกเลิก
          </button>
          <button 
            style={{padding: 0}}
            onClick={ () => {
              if (this.props.selectedRecord) {
                this.update()
              } else {
                this.save()
              }
            }} 
            className="m-05 btn btn-save-cancel btn-outline"
          >
            บันทึก
          </button>
          {
            this.props.selectedRecord ?
            <button 
              style={{padding: 0, width: '125px'}}
              onClick={ () => {
                this.delete()
              }}
              className="m-05 btn btn-red-outline"
            >
              ลบสื่อ
            </button> :
            null
          }
        </div>
      </div>
    )
  }
}

const CreateAdsModal = inModal(CreateAdsForm)

export default CreateAdsModal;

